import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createCrmConfig } from ".";
import { queryKeys } from "@/lib/useQuery/queryKeys";

export function useCreateCrmConfig() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: queryKeys.crm_config._def,
        mutationFn: createCrmConfig,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.crm_config._def, exact: false });
        }
    })
}